import { Button, ButtonGroup } from "@blueprintjs/core";
import { Customer } from "../../../api/schema";
import { TableColumns } from "../../../components/Table";
import { UserLanguage } from "../../../lang/lang";

interface Helper {
  on_delete: (item: Customer) => void;
  on_edit: (item: Customer) => void;
}

type CTC = (helper: Helper) => TableColumns<Customer>;

export const CustomerTableColoumns: CTC = (helper: Helper) => ({
  id: {
    label: UserLanguage().data.id,
  },
  name: {
    label: UserLanguage().data.customer.name,
  },
  company: {
    label: UserLanguage().data.customer.company,
  },
  invoice_address: {
    label: UserLanguage().data.customer.address,
  },
  actions: {
    label: UserLanguage().actions.label,
    render: (item) => (
      <ButtonGroup>
        <Button
          intent="primary"
          icon="edit"
          text={UserLanguage().actions.edit}
          onClick={() => helper.on_edit(item)}
        />
        <Button
          intent="danger"
          rightIcon="delete"
          text={UserLanguage().actions.delete}
          onClick={() => helper.on_delete(item)}
        />
      </ButtonGroup>
    ),
  },
});
